import { FhSideBarVisibleEmitterInterface } from '../../interfaces/fh-side-bar-visible-emitter/fh-side-bar-visible-emitter-interface';

export class FhSideBarVisibleEmitterModel implements FhSideBarVisibleEmitterInterface {
  id: string = '';
  route: string | undefined;

  constructor(init?: Partial<FhSideBarVisibleEmitterModel>) {
    Object.assign(this, init);
  }
}
